exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nfooter[data-v-6f737b4e] {\n  background-color: #ddd;\n}\nfooter .content-container[data-v-6f737b4e] {\n  padding: 20px 0;\n}\n", ""]);

// exports
